import React, { useMemo } from "react";
import { Row, Col } from "antd";
import {
  LeftSideInfo,
  MainContent,
} from "Components/fullscreen-configuration/trolley-component/trolley-component";
import { isEmpty } from "lodash";

interface TrolleyScreenProps {
  boxesToLoad: any[];
  upcomingBatches: any[];
  trolleyArray: any[];
}

const TrolleyFullScreen: React.FC<TrolleyScreenProps> = ({
  boxesToLoad,
  upcomingBatches,
  trolleyArray,
}) => {
  // normalise boxesToLoad and upcoming batches to have the same location
  const { normalisedBTL, normalisedUB } = useMemo(() => {
    let initialData: any = {
      normalisedBTL: [],
      normalisedUB: [],
    };

    if (isEmpty(upcomingBatches)) {
      return initialData;
    }

    // sort all the boxes by location
    let boxesByLocations: any = [];

    boxesToLoad.forEach((b) => {
      // find if the handoverpoint exists
      const hasLocation = boxesByLocations.findIndex((bl) => bl._id === b.handoverPoint);

      // hide prefixes
      const strippedBoxCode = b.boxCode.substring(8);

      // if it does, insert the boxCode
      if (hasLocation > -1) {
        boxesByLocations[hasLocation].boxList.push(strippedBoxCode);
        return;
      }

      // otherwise, create a new object
      boxesByLocations.push({
        _id: b.handoverPoint,
        name: b?.handoverPointData?.name,
        boxList: [strippedBoxCode],
      });
    });

    // sort upcoming batches by location
    let batchesByLocation: any = [];

    upcomingBatches.forEach((u) => {
      // find if the handoverpoint exists
      const hasLocation = batchesByLocation.findIndex((bl) => bl._id === u.handoverPoint);

      // if it does, insert the boxCode
      if (hasLocation > -1) {
        batchesByLocation[hasLocation].count += 1;
        return;
      }

      // otherwise, create a new object
      batchesByLocation.push({
        _id: u.handoverPoint,
        name: u?.handoverPointData?.name,
        count: 1,
      });
    });

    return {
      normalisedBTL: boxesByLocations,
      normalisedUB: batchesByLocation,
    };
  }, [boxesToLoad, upcomingBatches]);

  return (
    <div className="dm-fullscreen dm-fs-trolley">
      <Row gutter={[24, 0]}>
        <Col span={12} xl={8}>
          <LeftSideInfo boxesToLoad={normalisedBTL} upcomingBatches={normalisedUB} />
        </Col>
        <Col span={12} xl={16}>
          <MainContent trolleyArray={trolleyArray} />
        </Col>
      </Row>
    </div>
  );
};

export default TrolleyFullScreen;
